import { render, staticRenderFns } from "./ArchiveManagementDetail.vue?vue&type=template&id=d0daa70c&scoped=true"
import script from "./ArchiveManagementDetail.vue?vue&type=script&lang=js"
export * from "./ArchiveManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./ArchiveManagementDetail.vue?vue&type=style&index=0&id=d0daa70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0daa70c",
  null
  
)

export default component.exports